import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { useRouteError } from "react-router-dom";

export function RouteError() {
  const { t } = useTranslation("common");
  const error = useRouteError();
  // Loader threw (e.g. /auth/me failed). Don't fail-open into the app — show a
  // retry that reloads the route data.
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 px-4 text-center">
      <div className="text-lg font-semibold text-text">{t("routeError.title")}</div>
      <div className="text-sm text-text-muted">{t("routeError.description")}</div>
      <Button type="primary" onClick={() => window.location.reload()}>
        {t("routeError.retry")}
      </Button>
      {import.meta.env.DEV && <pre className="max-w-lg overflow-auto text-xs text-error">{String(error)}</pre>}
    </div>
  );
}
